// extracted by mini-css-extract-plugin
var _1 = "UfA09fR2ajT6YfBd5GGx";
var _2 = "vvaFuvc0QNf9SzCO74Mn";
export { _1 as "earn", _2 as "root" }
